import { useState } from "react";
import { HorasInputCard } from "./components/HorasExtrasInputCard";
import { ResponseHorasExtras } from "./horas-extras";
import { HorasExtrasResponse } from "./components/HorasExtrasResponse";


export default function HorasExtras() {
    const [results, setResults] = useState<ResponseHorasExtras | null>(null);

    return (
        <>

            <HorasInputCard setResults={setResults} />
            {results && <HorasExtrasResponse results={results} />}

        </>
    );
}